import Vue from 'vue';
import PhoneNumber from 'awesome-phonenumber';
import { extend, ValidationProvider, ValidationObserver } from 'vee-validate';
import {
  // eslint-disable-next-line
  required, email, ext, numeric, size, min_value,
} from 'vee-validate/dist/rules';
import VTextFieldWithValidation from '@/components/validators/VTextFieldWithValidation.vue';
import VAutocompleteWithValidation from '@/components/validators/VAutocompleteWithValidation.vue';
import VFileInputWithValidation from '@/components/validators/VFileInputWithValidation.vue';
import VSelectFieldWithValidation from '@/components/validators/VSelectFieldWithValidation.vue';
import parseDate from '@/utils/parseDate';
import dayjs from 'dayjs';

Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);
Vue.component('VTextFieldWithValidation', VTextFieldWithValidation);
Vue.component('VAutocompleteWithValidation', VAutocompleteWithValidation);
Vue.component('VFileInputWithValidation', VFileInputWithValidation);
Vue.component('VSelectFieldWithValidation', VSelectFieldWithValidation);

extend('required', {
  ...required,
  message: 'Toto pole je povinné',
});

extend('email', {
  ...email,
  message: 'E-mail nemá správný formát',
});

extend('phone', {
  message: 'Telefonní číslo není validní',
  validate(value) {
    return new Promise((resolve) => {
      const phone = new PhoneNumber(value);
      resolve({ valid: phone.isValid() });
    });
  },
});

extend('ext', {
  ...ext,
  message: 'Soubor nemá validní formát',
});

extend('ean', {
  message: 'EAN musí být číslo dlouhé 18 znaků',
  validate(ean) {
    const isNumber = (value) => !Number.isNaN(Number(value));
    return new Promise((resolve) => {
      resolve({ valid: ean.length === 18 && isNumber(ean) });
    });
  },
});

extend('dateFormat', {
  message: 'Datum nemá správný formát',
  validate(value) {
    let valueFormatted = null;
    if (value) {
      valueFormatted = parseDate(value);
    }
    return new Promise((resolve) => {
      resolve({ valid: valueFormatted ? dayjs(valueFormatted, 'Y-M-D').isValid() : false });
    });
  },
});

extend('interruptionDateAfter', {
  message: 'Požadavek na přerušení musí být zadán mínimálně 5 pracovních dní před požadavoaným termínem přerušení',
  validate(value, dateLimit) {
    let valueFormatted = null;
    if (value) {
      const parsedDate = parseDate(value);
      if (parsedDate) {
        valueFormatted = dayjs(parsedDate).add(1, 'day');
      }
    }
    return new Promise((resolve) => {
      resolve({ valid: valueFormatted ? dayjs(valueFormatted).isAfter(dateLimit[0]) : false });
    });
  },
});

extend('before', {
  message: 'Nesmí být zadáno datum v budoucnosti',
  validate(value, dateLimit) {
    let valueFormatted = null;
    if (value) {
      const parsedDate = parseDate(value);
      if (parsedDate) {
        valueFormatted = dayjs(parsedDate);
      }
    }
    return new Promise((resolve) => {
      resolve({ valid: valueFormatted ? dayjs(valueFormatted).isBefore(dateLimit[0]) : false });
    });
  },
});

extend('after', {
  message: 'Musí být zadáno datum v budoucnosti',
  validate(value, dateLimit) {
    let valueFormatted = null;
    if (value) {
      const parsedDate = parseDate(value);
      if (parsedDate) {
        valueFormatted = dayjs(parsedDate).add(1, 'day');
      }
    }
    return new Promise((resolve) => {
      resolve({ valid: valueFormatted ? dayjs(valueFormatted).isAfter(dateLimit[0]) : false });
    });
  },
});

extend('startDateAfter', {
  message: 'Požadovaný termín zahájení musí být první den následujícího měsíce',
  validate(value, dateLimit) {
    let valueFormatted = null;
    if (value) {
      const parsedDate = parseDate(value);
      if (parsedDate) {
        valueFormatted = dayjs(parsedDate).add(1, 'day');
      }
    }
    return new Promise((resolve) => {
      resolve({ valid: valueFormatted ? dayjs(valueFormatted).isAfter(dateLimit[0]) : false });
    });
  },
});

extend('dateWorkDay', {
  message: 'Zadané datum musí být pracovní den',
  validate(value) {
    let valueFormatted = null;
    if (value) {
      const parsedDate = parseDate(value);
      if (parsedDate) {
        valueFormatted = dayjs(parsedDate);
      }
    }
    return new Promise((resolve) => {
      resolve({ valid: valueFormatted ? (dayjs(valueFormatted).get('day') !== 0 && dayjs(valueFormatted).get('day') !== 6) : false });
    });
  },
});

extend('numeric', {
  ...numeric,
  message: 'Musí být zadáno číslo',
});

extend('size', {
  ...size,
  message: (value, args) => `Velikost souboru musí být menší než ${args.size} kB (${args.size / 1024} MB).`,
});

extend('min_value', {
  // eslint-disable-next-line
  ...min_value,
  message: (value, args) => `Velikost odečtu nesmí být menší než ${args.min} kWh.`,
});
